export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string = "UNKNOWN",
    readonly details: Record<string, unknown> = {},
  ) {
    super(message);
    this.name = "ApiError";
  }
  get isAuth(): boolean { return this.status === 401; }
  get isForbidden(): boolean { return this.status === 403; }
  get isNotFound(): boolean { return this.status === 404; }
  get isServer(): boolean { return this.status >= 500; }
  /** 재시도해서 나아질 수 있는가 — 에러 화면의 [다시 시도] 노출 기준. */
  get isRetryable(): boolean { return this.status === 0 || this.status === 408 || this.status >= 500; }
}

export class NetworkError extends ApiError {
  constructor(message = "연결이 끊겼어요. 네트워크를 확인해 주세요.") {
    super(message, 0, "NETWORK");
    this.name = "NetworkError";
  }
}
